import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import appstore from "../assets/images/appstore.png";
import playstore from "../assets/images/playstore.png";
import hero from "../assets/images/phone/2-phone.png";

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section
      className="relative w-full min-h-screen overflow-hidden flex items-center pt-40 sm:pt-48 md:pt-24 lg:pt-0"
      id="home"
    >
      {/* Clean Background with Grid Only */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Base gradient background */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-slate-100"></div>

        {/* Clean grid pattern */}
        <div className="absolute inset-0 opacity-40">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern
                id="grid"
                width="40"
                height="40"
                patternUnits="userSpaceOnUse"
              >
                <path
                  d="M 40 0 L 0 0 0 40"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1"
                  className="text-primaryColor/20"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
          </svg>
        </div>
      </div>

      <div className="container relative px-4 md:px-6 lg:px-8">
        <div className="relative grid md:grid-cols-12 grid-cols-1 items-center mt-6 gap-[20px]">
          <div className="md:col-span-6 text-center md:text-left">
            <div className="md:me-2">
              <div
                className={`transform transition-all ${
                  isVisible
                    ? "translate-y-0 opacity-100 scale-100"
                    : "translate-y-4 opacity-0 scale-95"
                }`}
              >
                <h4 className="font-bold lg:leading-normal leading-normal text-4xl lg:text-[40px] mb-5">
                  {t("hero.title")}
                </h4>
              </div>

              <div
                className={`transform transition-all duration-1200 ease-out delay-600 ${
                  isVisible
                    ? "translate-y-0 opacity-100 scale-100"
                    : "translate-y-4 opacity-0 scale-95"
                }`}
              >
                <p className="text-slate-400 text-lg max-w-xl mx-auto md:mx-0 mb-6">
                  {t("hero.description")}
                </p>
              </div>

              <div
                className={`transform transition-all duration-1200 ease-out delay-900 ${
                  isVisible
                    ? "translate-y-0 opacity-100 scale-100"
                    : "translate-y-4 opacity-0 scale-95"
                }`}
              >
                <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center lg:justify-start mb-4">
                  <Link
                    to="#"
                    className="inline-flex items-center px-2 md:px-4 py-1.5 md:py-2.5 bg-black text-white rounded-lg hover:bg-gray-900 transition-all duration-200 ease-in-out shadow-lg hover:shadow-xl w-full sm:w-auto justify-center transform hover:-translate-y-0.5 hover:scale-[1.02] active:scale-[0.98]"
                  >
                    <img
                      src={appstore}
                      alt="App Store"
                      className="h-8 md:h-10 w-auto mr-2 md:mr-3"
                    />
                    <div className="text-left">
                      <div className="text-xs opacity-75">
                        {t("footer.downloadAppStore")}
                      </div>
                      <div className="text-sm font-semibold">
                        {t("footer.appStore")}
                      </div>
                    </div>
                  </Link>

                  <Link
                    to="#"
                    className="inline-flex items-center px-2 md:px-4 py-1.5 md:py-2.5 bg-black text-white rounded-lg hover:bg-gray-900 transition-all duration-200 ease-in-out shadow-lg hover:shadow-xl w-full sm:w-auto justify-center transform hover:-translate-y-0.5 hover:scale-[1.02] active:scale-[0.98]"
                  >
                    <img
                      src={playstore}
                      alt="Google Play"
                      className="h-8 md:h-10 w-auto mr-2 md:mr-3"
                    />
                    <div className="text-left">
                      <div className="text-xs opacity-75">
                        {t("footer.getItOn")}
                      </div>
                      <div className="text-sm font-semibold">
                        {t("footer.googlePlay")}
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

              <div
                className={`transform transition-all duration-1200 ease-out delay-1200 ${
                  isVisible
                    ? "translate-y-0 opacity-100 scale-100"
                    : "translate-y-4 opacity-0 scale-95"
                }`}
              >
                <span className="text-primaryColor  font-medium">
                  {t("hero.contact")}
                </span>
                <span className="text-green-600 font-medium">
                  {t("hero.price")}
                </span>
              </div>
            </div>
          </div>

          <div className="md:col-span-6 flex justify-center md:justify-end">
            <div
              className="relative after:content-[''] after:absolute after:md:bottom-48 after:-bottom-20 lg:after:-start-10 md:after:-start-20 after:-start-24
                        after:bg-primaryColor after:shadow-2xl after:shadow-primaryColor/40 after:z-1 ltr:after:rotate-[130deg] rtl:after:-rotate-[130deg] after:w-[75rem] after:md:h-[45rem] after:h-[30rem] after:rounded-[30rem]"
            >
              <img
                src={hero}
                className="max-w-[200px] sm:max-w-[280px] md:max-w-md lg:max-w-[600px] relative z-2 mover"
                alt="Bossie App on Phone"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator with Mouse Animation - Hidden on Mobile */}
      <div className="hidden md:block absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div
          className={`flex flex-col items-center transition-all duration-700 ease-out delay-1000 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"
          }`}
        >
          <div className="w-6 h-10 mb-2 border-2 border-slate-300 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-primaryColor rounded-full mt-2 animate-bounce"></div>
          </div>
          <span className="text-xs text-slate-400 font-medium">
            {t("hero.scrollForDetails")}
          </span>
        </div>
      </div>
    </section>
  );
}
